(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5186],{

/***/ 37304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ getAgents; }
});

// UNUSED EXPORTS: getAgent

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/agent.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AgentStatic;

(function (AgentStatic) {
  AgentStatic["AgenciesList"] = "/v2/agents";
})(AgentStatic || (AgentStatic = {}));

var AgentDynamic = {
  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description get Agent details
   */
  AgentDetail: function AgentDetail(AgentID) {
    return "/v2/agents/".concat(AgentID);
  }
};
var agent_endpoint_AgentEndpoints = _objectSpread(_objectSpread({}, AgentDynamic), AgentStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/agent.request.ts


var getAgents = function getAgents(filters) {
  return (0,base_services_request/* getRequest */.A_)(agent_endpoint_AgentEndpoints.AgenciesList, filters).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
};
var getAgent = function getAgent(id) {
  return getRequest(AgentEndpoints.AgentDetail(id)).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  })["catch"](function (error) {
    return error.response;
  });
};

/***/ }),

/***/ 53541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);


function useGetPersistParams(config) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(); // if (config?.onlyId) {
  //   if (router?.query?.referer) {
  //     return router?.query?.referer as string;
  //   } else if (router?.query?.areferer) {
  //     return router?.query?.areferer as string;
  //   }
  // } else

  if (!(config !== null && config !== void 0 && config.onlyCode)) {
    var _router$query5, _router$query7;

    if (config !== null && config !== void 0 && config.onlyId) {
      var _router$query, _router$query3;

      if (router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.referer) {
        var _router$query2;

        return router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.referer;
      } else if (router !== null && router !== void 0 && (_router$query3 = router.query) !== null && _router$query3 !== void 0 && _router$query3.areferer) {
        var _router$query4;

        return router === null || router === void 0 ? void 0 : (_router$query4 = router.query) === null || _router$query4 === void 0 ? void 0 : _router$query4.areferer;
      }
    } else if (router !== null && router !== void 0 && (_router$query5 = router.query) !== null && _router$query5 !== void 0 && _router$query5.referer) {
      var _config$useConque, _router$query6;

      return "".concat((_config$useConque = config === null || config === void 0 ? void 0 : config.useConque) !== null && _config$useConque !== void 0 ? _config$useConque : "?", "referer=").concat(router === null || router === void 0 ? void 0 : (_router$query6 = router.query) === null || _router$query6 === void 0 ? void 0 : _router$query6.referer);
    } else if (router !== null && router !== void 0 && (_router$query7 = router.query) !== null && _router$query7 !== void 0 && _router$query7.areferer) {
      var _config$useConque2, _router$query8;

      return "".concat((_config$useConque2 = config === null || config === void 0 ? void 0 : config.useConque) !== null && _config$useConque2 !== void 0 ? _config$useConque2 : "?", "areferer=").concat(router === null || router === void 0 ? void 0 : (_router$query8 = router.query) === null || _router$query8 === void 0 ? void 0 : _router$query8.areferer);
    }
  } else {
    var _router$query9, _router$query11;

    if (router !== null && router !== void 0 && (_router$query9 = router.query) !== null && _router$query9 !== void 0 && _router$query9.referer) {
      var _router$query10;

      return {
        referer: router === null || router === void 0 ? void 0 : (_router$query10 = router.query) === null || _router$query10 === void 0 ? void 0 : _router$query10.referer
      };
    } else if (router !== null && router !== void 0 && (_router$query11 = router.query) !== null && _router$query11 !== void 0 && _router$query11.areferer) {
      var _router$query12;

      return {
        areferer: router === null || router === void 0 ? void 0 : (_router$query12 = router.query) === null || _router$query12 === void 0 ? void 0 : _router$query12.areferer
      };
    }
  }

  return "";
}

/* harmony default export */ __webpack_exports__["Z"] = (useGetPersistParams);

/***/ }),

/***/ 51860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
 // https://stackoverflow.com/questions/63406435/how-to-detect-window-size-in-next-js-ssr-using-react-hook

function useWindowSize() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    width: undefined,
    height: undefined
  }),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return windowSize;
}

/* harmony default export */ __webpack_exports__["Z"] = (useWindowSize);

/***/ }),

/***/ 75340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ collection; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(83618);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./shared/components/custom-carrusel/index.tsx
var custom_carrusel = __webpack_require__(20518);
// EXTERNAL MODULE: ./shared/components/messages-result/index.tsx
var messages_result = __webpack_require__(52659);
// EXTERNAL MODULE: ./api/agent.request.ts + 1 modules
var agent_request = __webpack_require__(37304);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/agent-collection-card-light/index.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








function AgentCollectionCardLight(props) {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("collection.certifiedAgents");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(ContentCard, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerCard, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerImg, null, (0,emotion_react_browser_esm/* jsx */.tZ)(UserImage, {
    src: props.picture,
    alt: props.name + "-" + props.id
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(LabelName, null, props.name), (0,emotion_react_browser_esm/* jsx */.tZ)(LabelSubtitle, null, translation("agentOf"), " ", props.agencia)), (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.collection_agent_detail */.K.es.collection_agent_detail({
      id: props.id,
      name: props.name
    }) + "?referer=" + props.id,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    bg: "--bg-secondary"
  }, translation("seeAgent")))));
}

/* harmony default export */ var agent_collection_card_light = (AgentCollectionCardLight);

var ContentCard = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kbt2rm6"
} : 0)( true ? {
  name: "1agncuk",
  styles: "width:80%;background:transparent;margin:0 auto;@media screen and (max-width: 500px){width:90%;margin:auto;}"
} : 0);

var ContainerCard = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kbt2rm5"
} : 0)( true ? {
  name: "ba1hru",
  styles: "border-radius:13px;text-align:center;width:100%;min-height:220px"
} : 0);

var ContainerButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kbt2rm4"
} : 0)( true ? {
  name: "zl1inp",
  styles: "display:flex;justify-content:center"
} : 0);

var ContainerImg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kbt2rm3"
} : 0)( true ? {
  name: "zov8s0",
  styles: "width:100%;display:flex;justify-content:center"
} : 0);

var LabelName = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1kbt2rm2"
} : 0)( true ? {
  name: "fxejr6",
  styles: "font-family:var(--font-family);font-style:normal;font-weight:700;font-size:16px;line-height:22px;display:block;color:var(--text-black);margin-top:10px"
} : 0);

var LabelSubtitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1kbt2rm1"
} : 0)( true ? {
  name: "1o02eu",
  styles: "font-family:var(--font-family);font-style:normal;font-weight:700;font-size:13px;line-height:16px;display:block;color:var(--color-brand-grey-secondary);margin-top:5px"
} : 0);

var UserImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1kbt2rm0"
} : 0)( true ? {
  name: "1v0myr5",
  styles: "width:130px;height:130px;border-radius:100%;object-fit:contain"
} : 0);
;// CONCATENATED MODULE: ./shared/components/slider-collection-agents/index.tsx




function slider_collection_agents_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









function SliderCollectionAgents() {
  var _data$data;

  var fetchProjectSlider = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,agent_request/* getAgents */.j)({
                page: 1,
                collections: true
              });

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchProjectSlider(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var _useMutation = (0,useMutation/* useMutation */.D)(["agents-slider"], fetchProjectSlider),
      data = _useMutation.data,
      isLoading = _useMutation.isLoading,
      isError = _useMutation.isError,
      mutate = _useMutation.mutate;

  react.useEffect(function () {
    mutate({});
  }, []);

  if (data && (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.length) > 0 && isLoading) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Sin Resultados"
    });
  }

  if (isError) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Ha ocurrido un error"
    });
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(custom_carrusel/* default */.Z, null, data === null || data === void 0 ? void 0 : data.data.map(function (item, i) {
    var _item$picture;

    return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, {
      key: i
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(agent_collection_card_light, {
      picture: (_item$picture = item.picture) !== null && _item$picture !== void 0 ? _item$picture : "/icons/remax-logo-01.svg",
      name: item.name,
      agencia: item.agency_name,
      id: item.id
    }));
  }))));
}

/* harmony default export */ var slider_collection_agents = (SliderCollectionAgents);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1sp45kx1"
} : 0)( true ? {
  name: "87d5hs",
  styles: "display:flex;justify-content:center;padding:10px 5px"
} : 0);

var CollectionButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "e1sp45kx0"
} : 0)( true ? {
  name: "132irba",
  styles: "width:100%;margin:auto;margin-top:20px;display:flex;justify-content:center"
} : 0);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./shared/components/a1-refactor/typography/WsSectionTitleWithThinTitle copy.tsx
var WsSectionTitleWithThinTitle_copy = __webpack_require__(71099);
;// CONCATENATED MODULE: ./shared/components-pages/collection/landing/agents-collections.tsx



function agents_collections_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function AgentsCollections() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("collection.certifiedAgents");
  var agentTitle = translation("title") || "";

  var _agentTitle$split = agentTitle.split(" "),
      _agentTitle$split2 = (0,toArray/* default */.Z)(_agentTitle$split),
      titleOne = _agentTitle$split2[0],
      titleTwo = _agentTitle$split2[1],
      rest = _agentTitle$split2.slice(2);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(ContentAgentsCollector, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    justifyContent: "center",
    mt: 4,
    mb: 5
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(WsSectionTitleWithThinTitle_copy/* default */.Z, {
    title: rest.join(" "),
    subtitle: "".concat(titleOne, " ").concat(titleTwo),
    color: "--color-brand-blue-collection-main"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(slider_collection_agents, null), (0,emotion_react_browser_esm/* jsx */.tZ)(agents_collections_CollectionButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.collection_agents_list */.K.es.collection_agents_list,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    bg: "--color-brand-red-tertiary"
  }, translation("seeMore")))));
}

/* harmony default export */ var agents_collections = (AgentsCollections);

var agents_collections_CollectionButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "e1xk6c231"
} : 0)( true ? {
  name: "qe273j",
  styles: "width:100%;margin:auto;margin-top:50px;display:flex;justify-content:center"
} : 0);

var ContentAgentsCollector = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xk6c230"
} : 0)( true ? {
  name: "np96ie",
  styles: "min-height:75vh;background:var(--color-brand-cream-primary);padding:70px 0px"
} : 0);
// EXTERNAL MODULE: ./shared/components/buy-sell-filter/index.tsx + 1 modules
var buy_sell_filter = __webpack_require__(97814);
;// CONCATENATED MODULE: ./shared/components-pages/collection/landing/cover-section.tsx



function cover_section_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function CoverSection() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("collection");
  var welcomeTitle = translation("title") || "";

  var _welcomeTitle$split = welcomeTitle.split(" "),
      _welcomeTitle$split2 = (0,toArray/* default */.Z)(_welcomeTitle$split),
      titleOne = _welcomeTitle$split2[0],
      titleTwo = _welcomeTitle$split2[1],
      rest = _welcomeTitle$split2.slice(2);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Cover, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentCover, null, (0,emotion_react_browser_esm/* jsx */.tZ)(TitlePrimary, null, titleOne, " ", titleTwo, " ", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, rest.join(" "))), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentFilter, null, (0,emotion_react_browser_esm/* jsx */.tZ)(buy_sell_filter/* default */.Z, {
    detailsRoute: pages_path/* CPagesPath.es.collection_property_detail */.K.es.collection_property_detail,
    collection: true
  }))));
}

/* harmony default export */ var cover_section = (CoverSection);

var ContentFilter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fxybo74"
} : 0)( true ? {
  name: "fgx8rm",
  styles: "display:flex;width:auto;justify-content:center;align-items:center;padding-top:15vh;@media screen and (max-width: 500px){padding-top:10vh;}"
} : 0);

var ContentCover = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fxybo73"
} : 0)( true ? {
  name: "4a98bl",
  styles: "width:80%;margin:auto;height:80vh"
} : 0);

var Cover = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "e1fxybo72"
} : 0)( true ? {
  name: "n5woff",
  styles: "background:linear-gradient(\n      180deg,\n      #0000 0%,\n      #0000 78%,\n      var(--color-brand-blue-collection-main) 100%\n    ),url(\"/images/v2/pic/imagen-08.webp\");width:100%;height:100vh;background-position:center;background-size:cover;background-repeat:no-repeat;padding:110px 0;margin-top:-34px;@media screen and (max-width: 500px){padding:70px 0;}"
} : 0);

var CicleImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1fxybo71"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

var TitlePrimary = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e1fxybo70"
} : 0)( true ? {
  name: "1yqd6d7",
  styles: "margin-top:5vh;text-transform:uppercase;font-weight:bold;font-size:3rem;color:white;font-family:var(--font-family);text-align:center;span{font-size:3rem;}@media screen and (max-width: 768px){margin-top:10vh;font-size:2rem;span{font-size:2rem;}}"
} : 0);
// EXTERNAL MODULE: ./shared/components/slider-collection-property/index.tsx
var slider_collection_property = __webpack_require__(2098);
;// CONCATENATED MODULE: ./shared/components-pages/collection/landing/featured-property.tsx



function featured_property_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function FeaturedProperty() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("collection.outstandingProperties");
  var featuredTitle = translation("title") || "";

  var _featuredTitle$split = featuredTitle.split(" "),
      _featuredTitle$split2 = (0,toArray/* default */.Z)(_featuredTitle$split),
      title = _featuredTitle$split2[0],
      rest = _featuredTitle$split2.slice(1);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerFeaturedProperty, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    mb: 4
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(WsSectionTitleWithThinTitle_copy/* default */.Z, {
    title: rest.join(" "),
    subtitle: title,
    color: "white"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(slider_collection_property/* default */.Z, null), (0,emotion_react_browser_esm/* jsx */.tZ)(featured_property_CollectionButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.collection_properties */.K.es.collection_properties,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a"
  }, translation("seeMore")))));
}

/* harmony default export */ var featured_property = (FeaturedProperty);

var featured_property_CollectionButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "ew278nt1"
} : 0)( true ? {
  name: "qe273j",
  styles: "width:100%;margin:auto;margin-top:50px;display:flex;justify-content:center"
} : 0);

var ContainerFeaturedProperty = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ew278nt0"
} : 0)( true ? {
  name: "17r46in",
  styles: "width:100%;height:100%;margin-top:150px;& h2{padding-bottom:10px;}@media screen and (max-width: 600px){margin-top:100px;}"
} : 0);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./shared/components-pages/collection/landing/info-video-section.tsx






function InfoVideoSection() {
  var opts = {
    width: "100%",
    height: "450px",
    frameBorder: 2,
    playerVars: {
      autoplay: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      control: 0
    }
  };
  var translation = (0,next_intl_cjs_production_min.useTranslations)("collection.remaxCollection");

  var _useState = (0,react.useState)(true),
      hiddenIframe = _useState[0],
      IsHiddenFrame = _useState[1];

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    rowGap: 2,
    alignItems: "center",
    px: 2
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    md: 7,
    mb: 4,
    maxWidth: 450
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
    color: "white",
    textAlign: "center"
  }, translation("description")), (0,emotion_react_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
    color: "white",
    textAlign: "center"
  }, translation("team"))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    md: 5,
    sx: {
      width: {
        xs: "100%",
        md: "50%"
      },
      height: {
        xs: "300px"
      }
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(YouTube_esm/* default */.Z, {
    videoId: "Ta1P6nRn03Y",
    opts: opts,
    onEnd: function onEnd() {
      IsHiddenFrame(true);
    }
  })));
}

/* harmony default export */ var info_video_section = (InfoVideoSection);
// EXTERNAL MODULE: ./shared/components/head-meta/index.tsx
var head_meta = __webpack_require__(23385);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./shared/models/const/keywords.const.ts
var keywords_const = __webpack_require__(6644);
;// CONCATENATED MODULE: ./pages/collection/index.tsx


function collection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var Collection = function Collection(props) {
  var router = (0,next_router.useRouter)();
  var metaData = {
    title: "collection",
    keyWords: keywords_const/* CKeyWordsPages.homeCollections */.k.homeCollections,
    description: "collections",
    url: router.asPath,
    picture: "/images/image-optimize/remax-collection-cover_meta.jpg"
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    style: {
      backgroundColor: "var(--color-brand-cream-primary)"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(head_meta/* default */.Z, metaData), (0,emotion_react_browser_esm/* jsx */.tZ)(cover_section, null), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentCurve, null, (0,emotion_react_browser_esm/* jsx */.tZ)(info_video_section, null), (0,emotion_react_browser_esm/* jsx */.tZ)(collection_ContainerFeaturedProperty, null, (0,emotion_react_browser_esm/* jsx */.tZ)(featured_property, null))), (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerAgents, null, (0,emotion_react_browser_esm/* jsx */.tZ)(agents_collections, null)));
};

var __N_SSG = true;
/* harmony default export */ var collection = (Collection);

var collection_ContainerFeaturedProperty = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eknwuxn2"
} : 0)( true ? {
  name: "h34vad",
  styles: "margin:auto;width:100%;padding-bottom:80px"
} : 0);

var ContainerAgents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eknwuxn1"
} : 0)( true ? {
  name: "h34vad",
  styles: "margin:auto;width:100%;padding-bottom:80px"
} : 0);

var ContentCurve = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eknwuxn0"
} : 0)( true ? {
  name: "sbzvlz",
  styles: "width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;padding-top:100px;background:var(--color-brand-blue-collection-main);border-radius:0px 0px 0px 200px;@media screen and (max-width: 600px){border-radius:0px;}"
} : 0);

/***/ }),

/***/ 71099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70917);


var _templateObject;




function WsSectionTitleWithThinTitle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      color = _ref.color,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "1.6rem" : _ref$fontSize;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    container: true,
    item: true,
    xs: 12,
    justifyContent: "center",
    spacing: 1
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    item: true,
    xs: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(Title, {
    fontSize: fontSize,
    fontWeight: 700,
    color: color
  }, title)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    item: true,
    xs: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(Title, {
    fontSize: fontSize,
    fontWeight: 400,
    color: color
  }, subtitle)));
}

/* harmony default export */ __webpack_exports__["Z"] = (WsSectionTitleWithThinTitle);
var Title = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject || (_templateObject = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  font-size: 1.8rem;\n  @media screen and (max-width: 768px) {\n    font-size: 1.4rem;\n  }\n"])));

/***/ }),

/***/ 97814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ buy_sell_filter; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./shared/components/advance-filter-dialog/index.tsx + 14 modules
var advance_filter_dialog = __webpack_require__(64255);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(25662);
// EXTERNAL MODULE: ./node_modules/@mui/material/Badge/Badge.js + 2 modules
var Badge = __webpack_require__(19529);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./custom-hooks/use-width.hook.ts
var use_width_hook = __webpack_require__(44231);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./shared/models/const/property-types.ts
var property_types = __webpack_require__(86465);
// EXTERNAL MODULE: ./api/realestate.request.ts + 1 modules
var realestate_request = __webpack_require__(13897);
// EXTERNAL MODULE: ./shared/components/message-modal/index.tsx
var message_modal = __webpack_require__(36481);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/material/RadioGroup/RadioGroup.js + 1 modules
var RadioGroup = __webpack_require__(79717);
// EXTERNAL MODULE: ./node_modules/@mui/material/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(36872);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 5 modules
var FormControlLabel = __webpack_require__(60856);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/react/use-intl.esm2.js + 1 modules
var use_intl_esm2 = __webpack_require__(62265);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/buy-sell-filter/RadioGroupStatus.tsx




var _excluded = ["isCollection"];






var CustomLabel = function CustomLabel(_ref) {
  var active = _ref.active,
      label = _ref.label,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledCheckbox, {
    checked: active,
    onClick: onChange
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(StyledLabel, null, label));
};

var RadioGroupStatus = function RadioGroupStatus(_ref2) {
  var isCollection = _ref2.isCollection,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  var t = (0,use_intl_esm2/* default */.Z)("buy-sell-filter");

  var _useField = (0,formik_esm/* useField */.U$)(props),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var onChange = function onChange() {
    var value = field.value === "sale" ? "lease" : "sale";
    helpers.setValue(value);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(StyledFormControl, null, (0,emotion_react_browser_esm/* jsx */.tZ)(RadioGroup/* default */.Z, (0,esm_extends/* default */.Z)({
    row: true
  }, field), (0,emotion_react_browser_esm/* jsx */.tZ)(StyledFormControlLabel, {
    className: "".concat(field.value === "sale" ? "active" : "", " ").concat(isCollection ? "collection" : ""),
    value: "sale",
    control: (0,emotion_react_browser_esm/* jsx */.tZ)(Radio/* default */.Z, null),
    label: (0,emotion_react_browser_esm/* jsx */.tZ)(CustomLabel, {
      label: t("shop"),
      active: field.value === "sale",
      onChange: onChange
    })
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(StyledFormControlLabel, {
    value: "lease",
    className: "".concat(field.value === "lease" ? "active" : "", " ").concat(isCollection ? "collection" : ""),
    control: (0,emotion_react_browser_esm/* jsx */.tZ)(Radio/* default */.Z, null),
    label: (0,emotion_react_browser_esm/* jsx */.tZ)(CustomLabel, {
      label: t("sell"),
      active: field.value === "lease",
      onChange: onChange
    })
  })));
};

var StyledFormControl = (0,styled/* default */.ZP)(FormControl/* default */.Z)(function (_ref3) {
  var _MuiFormGroupRoot;

  var theme = _ref3.theme;
  return {
    "& .MuiFormGroup-root": (_MuiFormGroupRoot = {
      display: "flex",
      flexWrap: "nowrap",
      position: "relative",
      left: 40,
      bottom: -3
    }, (0,defineProperty/* default */.Z)(_MuiFormGroupRoot, theme.breakpoints.down("lg"), {
      left: 20
    }), (0,defineProperty/* default */.Z)(_MuiFormGroupRoot, theme.breakpoints.down("md"), {
      left: 20
    }), _MuiFormGroupRoot)
  };
});
var StyledFormControlLabel = (0,styled/* default */.ZP)(FormControlLabel/* default */.Z)(function (_ref4) {
  var _ref5;

  var theme = _ref4.theme;
  return _ref5 = {
    margin: 0,
    backgroundColor: "var(--color-brand-red-main)",
    color: "#fff",
    padding: "8px 20px",
    border: "none",
    outline: "none",
    borderRadius: "10px 10px 0px 0px"
  }, (0,defineProperty/* default */.Z)(_ref5, theme.breakpoints.down("lg"), {
    borderRadius: "10px"
  }), (0,defineProperty/* default */.Z)(_ref5, theme.breakpoints.down("md"), {
    borderRadius: "10px"
  }), (0,defineProperty/* default */.Z)(_ref5, "&.active", {
    backgroundColor: "var(--color-brand-red-tertiary)",
    transform: "scale(1.1)",
    transition: "0.2s",
    fontSize: "12px"
  }), (0,defineProperty/* default */.Z)(_ref5, "& .MuiRadio-root", {
    display: "none",
    textAlign: "center"
  }), (0,defineProperty/* default */.Z)(_ref5, "& .MuiFormControlLabel-label", {
    cursor: "pointer",
    fontWeight: 500,
    fontFamily: "var(--font-family)",
    width: "100%",
    textAlign: "center",
    fontSize: "12px"
  }), (0,defineProperty/* default */.Z)(_ref5, "&.collection", {
    backgroundColor: "var(--color-brand-blue-main)"
  }), (0,defineProperty/* default */.Z)(_ref5, "&.collection.active", {
    backgroundColor: "#404041"
  }), _ref5;
});
var StyledLabel = (0,styled/* default */.ZP)("span")({
  cursor: "pointer",
  fontWeight: 500,
  fontFamily: "var(--font-family)",
  width: "100%",
  textAlign: "center",
  fontSize: "12px"
});
var StyledCheckbox = (0,styled/* default */.ZP)(Checkbox/* default */.Z)({
  padding: 0,
  marginRight: 5,
  "& .MuiSvgIcon-root": {
    width: 15,
    height: 15,
    color: "var(--color-brand-bg-secondary)"
  }
});
/* harmony default export */ var buy_sell_filter_RadioGroupStatus = (RadioGroupStatus);
// EXTERNAL MODULE: ./shared/components/auto-complete-field/index.tsx + 2 modules
var auto_complete_field = __webpack_require__(69891);
// EXTERNAL MODULE: ./shared/components/buy-sell-filter/util/form.util.ts
var form_util = __webpack_require__(2553);
// EXTERNAL MODULE: ./custom-hooks/use-cities.hook.ts + 2 modules
var use_cities_hook = __webpack_require__(78647);
// EXTERNAL MODULE: ./shared/models/functions/cities.helper.ts
var cities_helper = __webpack_require__(75769);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./shared/components/buy-sell-filter/index.tsx



var buy_sell_filter_excluded = ["citie", "description", "isSector"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















function BuySellFilter(props) {
  var t = (0,next_intl_cjs_production_min.useTranslations)("buy-sell-filter");
  var translationNotFound = (0,next_intl_cjs_production_min.useTranslations)("buy-sell-filter.notFound");
  var translation = (0,next_intl_cjs_production_min.useTranslations)("realestateList.typeFilters");
  var width = (0,use_width_hook/* useWidth */.z)();
  var isMobile = ["xs", "sm"].includes(width);
  var ref = (0,react.useRef)(null);
  var refButton = (0,react.useRef)();
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(""),
      search = _useState[0],
      onSearch = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var propertyTypes = (0,property_types/* useIntlPropertyTypes */.Pb)();
  var isCollection = router.asPath.includes(pages_path/* CPagesPath.es.collection */.K.es.collection);
  var propertyDetailRedirect = isCollection ? pages_path/* CPagesPath.es.collection_property_detail */.K.es.collection_property_detail : pages_path/* CPagesPath.es.property_detail */.K.es.property_detail;
  var collectionProperties = [translation("house"), translation("apartment"), translation("tourist"), translation("penthouse"), translation("project")];
  var collectionTypes = propertyTypes.filter(function (e) {
    return collectionProperties.includes(e.name);
  });
  var types = props.collection ? collectionTypes : propertyTypes;
  var handleSearch = react.useCallback(function (e) {
    var values = e.target.value;
    onSearch(values);
  }, []);

  var handleOpenModal = function handleOpenModal() {
    setOpen(true);
  };

  var handleCloseModal = function handleCloseModal() {
    setOpen(false);
  };

  var citiesList = (0,use_cities_hook/* default */.Z)({
    q: search
  }, 500);
  var getRealestateRequest = (0,useMutation/* useMutation */.D)(["detail-realstate"], function (realestateId) {
    return (0,realestate_request/* getRealestateDetails */.mW)(realestateId);
  });
  var submitValues = (0,lodash.debounce)(function (value) {
    var realestateId = parseInt(search);

    if (Boolean(realestateId)) {
      getRealestateRequest.mutateAsync(realestateId).then(function (r) {
        router.push({
          pathname: propertyDetailRedirect(r.data),
          query: _objectSpread(_objectSpread({}, router.query), props.params)
        });
      })["catch"](function () {
        return handleOpenModal();
      });
    } else {
      var _props$redirect;

      var route = (_props$redirect = props.redirect) !== null && _props$redirect !== void 0 ? _props$redirect : (router.pathname.length > 1 ? router.pathname : "") + pages_path/* CPagesPath.es.properties */.K.es.properties;
      var params = (0,form_util/* makeFilterObject */.U)(_objectSpread(_objectSpread({}, value), props.params));
      router.push({
        pathname: route,
        query: params
      });
    }
  }, 500);

  var handleLocationChange = function handleLocationChange(e, newValue) {
    // if enter was pressed
    if (e.keyCode === 13 && Boolean(parseInt(search))) {
      submitValues({});
    } else if (ref.current) {
      if (newValue.length == 2) {
        ref.current.setFieldValue("locations", [newValue[1]]);
        return;
      }

      ref.current.setFieldValue("locations", newValue);
    }
  };

  var isLoading = function isLoading() {
    if (Boolean(parseInt(search))) {
      return false;
    }

    return citiesList.isLoading;
  };

  var handleModal = function handleModal() {
    refButton.current.click();
  };

  var Cities_Options = citiesList.data ? (0,cities_helper/* default */.Z)(citiesList.data) : [];
  var Cities_noOptionsText = !((search === null || search === void 0 ? void 0 : search.length) > 2) ? t("searchHelp") : t("searchHelpSD");
  var initialValues = props.values ? props.values : form_util/* FormConfig.initialValues */.Z.initialValues;
  var handleSubmit = props.onSubmit ? props.onSubmit : submitValues;

  var Cities_getOptionLabel = function Cities_getOptionLabel(option) {
    return option === null || option === void 0 ? void 0 : option.description;
  };

  var Cities_renderOptions = function Cities_renderOptions(props, option) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(ItemElementLabel, (0,esm_extends/* default */.Z)({}, props, option));
  };

  var FormikConfig = {
    innerRef: ref,
    initialValues: initialValues,
    onSubmit: handleSubmit,
    enableReinitialize: true
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(FilterContent, {
    className: props.className
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(formik_esm/* Formik */.J9, FormikConfig, function (formikProp) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(CoverSearch, {
      id: "cover_search"
    }, !isMobile && (0,emotion_react_browser_esm/* jsx */.tZ)(buy_sell_filter_RadioGroupStatus, {
      name: "businessTypes",
      isCollection: props.collection
    }), (0,emotion_react_browser_esm/* jsx */.tZ)(CoverSearchBody, {
      className: "content-body",
      isCollection: props.collection
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      container: true
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 4,
      className: "typeProperty-autocomplete-container"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Label, null, t("youLookingFor")), (0,emotion_react_browser_esm/* jsx */.tZ)(CoverAutoComplete, {
      name: "typeProperty",
      limitTags: 1,
      multiple: true,
      className: "typeProperty-autocomplete",
      placeholder: t("typePlaceholder"),
      getOptionLabel: function getOptionLabel(option) {
        return option === null || option === void 0 ? void 0 : option.description;
      },
      options: types.map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          description: x.name,
          id: x.id
        });
      })
    })), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)(DividerSearch, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: true,
      onClick: function onClick(e) {
        if (isMobile) {
          e.preventDefault();
          handleModal();
        }
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Label, null, t("where")), (0,emotion_react_browser_esm/* jsx */.tZ)(LocationAutoComplete, {
      name: "locations",
      limitTags: 1,
      multiple: true,
      INPUT_DELAY: 600,
      loading: isLoading(),
      options: Cities_Options,
      onInputChange: handleSearch,
      className: "city-autocomplete",
      onChange: handleLocationChange,
      renderOption: Cities_renderOptions,
      value: formikProp.values.locations,
      noOptionsText: Cities_noOptionsText,
      freeSolo: Boolean(parseInt(search)),
      placeholder: t("locationPlaceholder"),
      getOptionLabel: Cities_getOptionLabel
    }))), (0,emotion_react_browser_esm/* jsx */.tZ)(ButtonSubmit, {
      type: "submit",
      isCollection: props.collection
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
      src: "/icons/loupe_remax_rd.svg",
      alt: "Loupe icon",
      width: "35px",
      height: "35px"
    }))), !props.collection && (0,emotion_react_browser_esm/* jsx */.tZ)(advance_filter_dialog/* default */.Z, {
      handleReset: formikProp.handleReset,
      handleSubmit: formikProp.handleSubmit,
      refButton: refButton
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(ButtonFilter, {
      type: "button",
      isCollection: props.collection
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
      src: "/icons/filter_remax_rd.svg",
      alt: "Filter icon",
      width: "11px",
      height: "11px"
    }), " ", t("AdvanceFilters"), props.filtersCount > 0 && (0,emotion_react_browser_esm/* jsx */.tZ)(buy_sell_filter_Badge, null, props.filtersCount))));
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(message_modal/* ModalMessage */.P, {
    title: translationNotFound("title"),
    body: translationNotFound("body"),
    variant: "error",
    open: open,
    handleClose: handleCloseModal
  }));
}

/* harmony default export */ var buy_sell_filter = (BuySellFilter);

var ItemElementLabel = function ItemElementLabel(props) {
  var citie = props.citie,
      description = props.description,
      isSector = props.isSector,
      rest = (0,objectWithoutProperties/* default */.Z)(props, buy_sell_filter_excluded);

  var Wrap = (description === null || description === void 0 ? void 0 : description.length) > 8 ? "wrap" : "";
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, (0,esm_extends/* default */.Z)({
    component: "li",
    sx: {
      width: "100%",
      display: "flex",
      "&.MuiAutocomplete-option.Mui-focused": {
        backgroundColor: "transparent",
        "&:hover span": {
          color: "white"
        }
      },
      "& .noWrap": {
        whiteSpace: "nowrap"
      },
      "& span": {
        color: "var(--color-brand-blue-main)",
        fontWeight: "bold",
        marginRight: "5px"
      },
      "& .isCity, .isSector": {
        color: "var(--color-brand-blue-main)"
      },
      "& .description": {
        color: "#989694",
        lineHeight: "20px"
      },
      "@media screen and (max-width: 450px)": {
        flexDirection: "column",
        alignItems: "start",
        whiteSpace: "nowrap",
        textAlign: "left",
        fontSize: "13px",
        "& .isCity": {
          width: "100%"
        },
        "& .description": {
          textAlign: "left",
          fontWeight: 400,
          width: "100%"
        }
      }
    }
  }, rest), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "noWrap isCity"
  }, description));
};

var Label = (0,styled/* default */.ZP)("span")({
  fontSize: "0.9rem",
  fontWeight: 600,
  cursor: "pointer",
  color: "var(--color-text-primary)"
});
var ButtonSubmit = (0,styled/* default */.ZP)(Button/* default */.Z)(function (_ref) {
  var isCollection = _ref.isCollection;
  return _objectSpread(_objectSpread({
    backgroundColor: "black",
    ":hover": {
      backgroundColor: "var(--color-brand-red-tertiary)"
    },
    border: "none",
    outline: "none",
    padding: "10px 20px",
    borderRadius: "15px",
    position: "absolute",
    right: "-10px",
    alignSelf: "center",
    cursor: "pointer"
  }, isCollection && {
    backgroundColor: "var(--color-brand-blue-main)",
    "&:hover": {
      backgroundColor: "var(--color-brand-blue-main)"
    }
  }), {}, {
    "& img": {
      verticalAlign: "middle"
    },
    "@media screen and (max-width: 767px)": {
      "& img": {
        width: "20px"
      }
    },
    "@media screen and (max-width: 450px)": {
      right: "-10px"
    }
  });
});
var DividerSearch = (0,styled/* default */.ZP)(Grid/* default */.ZP)({
  borderLeft: "1px solid var(--color-brand-blue-main)",
  height: "49px",
  width: "1px",
  margin: "auto 10px",
  marginTop: "5px",
  "@media screen and (max-width: 740px)": {
    display: "none"
  }
});
var ButtonFilter = (0,styled/* default */.ZP)(Button/* default */.Z)(function (_ref2) {
  var isCollection = _ref2.isCollection;
  return _objectSpread(_objectSpread({
    position: "absolute",
    top: "100%",
    right: "80px",
    backgroundColor: "var(--color-brand-red-main)",
    ":hover": {
      backgroundColor: "var(--color-brand-red-tertiary)"
    }
  }, isCollection && {
    backgroundColor: "var(--color-brand-blue-main)",
    "&:hover": {
      backgroundColor: "var(--color-brand-blue-main)"
    }
  }), {}, {
    textTransform: "none",
    color: "var(--color-text-white)",
    padding: "10px 22px",
    border: "none",
    outline: "none",
    borderRadius: "0 0 10px 10px",
    fontSize: "0.85rem",
    cursor: "pointer",
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    "& img": {
      verticalAlign: "middle"
    },
    "@media screen and (max-width: 767px)": {
      marginBottom: "20px"
    }
  });
});
var CoverSearchBody = (0,styled/* default */.ZP)(Box/* default */.Z)(function (_ref3) {
  var isCollection = _ref3.isCollection;
  return _objectSpread(_objectSpread({
    backgroundColor: "#fff",
    position: "relative",
    zIndex: 10,
    padding: "8px 38px 10px 33px",
    borderRadius: "50px"
  }, isCollection && {
    borderRadius: "15px"
  }), {}, {
    display: "flex",
    height: "75px",
    "@media screen and (max-width: 767px)": {
      flexWrap: "wrap",
      padding: "15px 30px",
      height: "auto"
    },
    "@media screen and (max-width: 450px)": {
      borderRadius: "10px",
      padding: "15px 15px"
    }
  });
});
var CoverSearch = (0,styled/* default */.ZP)(formik_esm/* Form */.l0)({
  position: "relative",
  width: "840px",
  "@media screen and (max-width: 991px)": {
    width: "700px"
  },
  "@media screen and (max-width: 891px)": {
    width: "600px"
  },
  "@media screen and (max-width: 740px)": {
    width: "570px"
  },
  "@media screen and (max-width: 732px)": {
    width: "520px"
  },
  "@media screen and (max-width: 630px)": {
    width: "440px"
  },
  "@media screen and (max-width: 450px)": {
    width: "340px"
  }
});
var CoverAutoComplete = (0,styled/* default */.ZP)(auto_complete_field/* default */.Z)({
  width: "100%",
  border: "none",
  outline: "none",
  padding: "0px",
  "& .MuiAutocomplete-input": {
    padding: "4px 6px !important"
  },
  "& .MuiPaper-root.MuiAutocomplete-noOptions": {
    textTransform: "initial !important"
  },
  "& .MuiInputBase-fullWidth.MuiInputBase-root": {
    flexWrap: "nowrap",
    "&.Mui-focused": {
      position: "absolute",
      flexWrap: "wrap"
    }
  },
  "& .MuiInputBase-root": {
    marginTop: "-0.7rem !important",
    padding: "0px !important",
    backgroundColor: "white",
    "& *": {
      border: "none !important"
    }
  },
  "& .MuiAutocomplete-tag": {
    maxWidth: "110px",
    backgroundColor: "var(--color-brand-blue-main)",
    color: "white",
    fontWeight: 500
  },
  "& .MuiChip-deleteIcon": {
    color: "white !important"
  },
  "& span.MuiAutocomplete-tagSizeMedium": {
    borderRadius: "100%",
    width: "20px",
    height: "20px",
    fontSize: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  "& .Mui-focused .MuiAutocomplete-tag": {
    maxWidth: "calc(100% - 6px)"
  },
  "& .city-autocomplete": {
    width: "100%"
  }
});
var LocationAutoComplete = (0,styled/* default */.ZP)(auto_complete_field/* AutoCompleteField */.K)({
  width: "100%",
  border: "none",
  outline: "none",
  padding: "0px",
  "& .MuiAutocomplete-input": {
    padding: "4px 6px !important"
  },
  "& .MuiPaper-root.MuiAutocomplete-noOptions": {
    textTransform: "initial !important"
  },
  "& .MuiInputBase-fullWidth.MuiInputBase-root": {
    flexWrap: "nowrap",
    "&.Mui-focused": {
      position: "absolute",
      flexWrap: "wrap"
    }
  },
  "& .MuiInputBase-root": {
    marginTop: "-0.7rem !important",
    padding: "0px !important",
    backgroundColor: "white",
    "& *": {
      border: "none !important"
    }
  },
  "& .MuiAutocomplete-tag": {
    backgroundColor: "var(--color-brand-blue-main)",
    color: "white",
    fontWeight: 500
  },
  "& .MuiChip-deleteIcon": {
    color: "white !important"
  },
  "& span.MuiAutocomplete-tagSizeMedium": {
    borderRadius: "100%",
    width: "20px",
    height: "20px",
    fontSize: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  "& .Mui-focused .MuiAutocomplete-tag": {
    maxWidth: "calc(100% - 6px)"
  },
  "& .city-autocomplete": {
    width: "100%"
  }
});
var FilterContent = (0,styled/* default */.ZP)(Box/* default */.Z)({
  margin: "auto",
  "@media screen and (max-width: 740px)": {
    "& .typeProperty-autocomplete-container": {
      display: "none"
    }
  }
});
var buy_sell_filter_Badge = (0,styled/* default */.ZP)(Badge/* default */.Z)({
  minWidth: "20px",
  minHeight: "20px",
  borderRadius: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  color: "var(--color-brand-bg-secondary)",
  backgroundColor: "var(--color-brand-blue-main)",
  fontSize: "0.75rem",
  fontWeight: 600,
  top: "18px",
  right: "0"
});

/***/ }),

/***/ 20518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_ArrowBackIosNewRounded__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76083);
/* harmony import */ var _mui_icons_material_ArrowForwardIosRounded__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47111);
/* harmony import */ var custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44231);
/* harmony import */ var _slick_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84256);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90948);


var _templateObject;










function CustomCarrusel(props) {
  var _props$colorArrow, _props$colorArrow2, _props$children, _props$numberOfPlaceh;

  var width = (0,custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_2__/* .useWidth */ .z)();
  var rows = {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4
  };
  var arrowsLeft =
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", (_props$colorArrow = props.colorArrow) !== null && _props$colorArrow !== void 0 ? _props$colorArrow : "var(--color-brand-blue-main)", "!important;font-size:clamp(1.5rem, 2.5vw, 2.6rem);padding:2px;position:absolute;z-index:500;left:", width === "xs" || width === "sm" ? "-25px" : "-50px", "!important;top:50%;transform:translateY(-50%);@media (max-width: 600px){left:-15px!important;font-size:1.8rem;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);
  var arrowsRight =
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", (_props$colorArrow2 = props.colorArrow) !== null && _props$colorArrow2 !== void 0 ? _props$colorArrow2 : "var(--color-brand-blue-main)", "!important;font-size:clamp(1.5rem, 2.5vw, 2.6rem);padding:2px;position:absolute;z-index:500;right:", width === "xs" || width === "sm" ? "-25px" : "-50px", "!important;top:50%;transform:translateY(-50%);@media (max-width: 600px){right:-15px!important;font-size:1.8rem;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);
  var settings = {
    dots: false,
    infinite: ((_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.length) > rows[width],
    speed: 500,
    slidesToShow: rows[width],
    slidesToScroll: 1,
    centerMode: false,
    nextArrow: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_icons_material_ArrowForwardIosRounded__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      css: arrowsRight
    }),
    prevArrow: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_icons_material_ArrowBackIosNewRounded__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      css: arrowsLeft
    }),
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false
      }
    }, {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false
      }
    }]
  };
  var fakeElements = Array.from({
    length: (_props$numberOfPlaceh = props.numberOfPlaceholderItems) !== null && _props$numberOfPlaceh !== void 0 ? _props$numberOfPlaceh : 5
  }, function (v, i) {
    return i;
  });
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(CarruselContainer, {
    container: true,
    justifyContent: "center"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
    item: true,
    xs: 11,
    sm: 11,
    md: 11,
    lg: 10,
    xl: 10,
    my: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_slick_slider__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, settings, !(props !== null && props !== void 0 && props.children) && props.enablePlaceholder && fakeElements.map(function (e, i) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(props.placeholderItem, {
      key: i
    });
  }), (props === null || props === void 0 ? void 0 : props.children) && props.children)));
}

/* harmony default export */ __webpack_exports__["Z"] = (CustomCarrusel);
var CarruselContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  position: relative;\n  margin: 5px 0px;\n  \n  & .slick-slider {\n  \n    position: relative;\n  }\n  \n  & .slick-arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 10;\n    \n    &:before {\n      display: none;\n    }\n  }\n  \n  & .slick-prev {\n    left: -40px;\n    \n    @media (max-width: 900px) {\n      left: -25px;\n    }\n    \n    @media (max-width: 600px) {\n      left: -10px;\n    }\n  }\n  \n  & .slick-next {\n    right: -40px;\n    \n    @media (max-width: 900px) {\n      right: -25px;\n    }\n    \n    @media (max-width: 600px) {\n      right: -10px;\n    }\n  }\n  \n  & .slick-list {\n    overflow: hidden;\n  }\n  \n  & .slick-track {\n    display: flex;\n    align-items: stretch;\n  }\n  \n  & .slick-slide {\n    > div {\n      height: 100%;\n    }\n  }\n"])));

/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72717);
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);






function HeadMeta(props) {
  var title = props.title,
      description = props.description,
      url = props.url,
      og_type = props.og_type,
      picture = props.picture,
      canonical = props.canonical,
      keyWords = props.keyWords;
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("title-pages");
  var MetaDescriptionT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("metaDescriptions");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default()), null, title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", null, titleT(title)), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: description
  }), keyWords && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: keyWords
  }), url && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:url",
    content: "".concat("https://unete.remaxrd.com").concat(url)
  }), og_type && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:type",
    content: og_type
  }), title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:title",
    content: title
  }), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:description",
    content: MetaDescriptionT(description)
  }), picture && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:image",
    content: "https://unete.remaxrd.com" + picture
  }), (url || canonical) && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("".concat("https://unete.remaxrd.com").concat(canonical !== null && canonical !== void 0 ? canonical : url)),
    key: "canonical"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeadMeta);

/***/ }),

/***/ 78836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var LabelField = function LabelField(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
    css: styles.label,
    className: "label-customs ".concat(props.positionLabel)
  }, props.label);
};

/* harmony default export */ __webpack_exports__["Z"] = (LabelField);
var styles = {
  label:  true ? {
    name: "8knltz",
    styles: "width:100%;display:block;padding-left:10px;font-size:0.9375rem;font-weight:600;line-height:21px;color:var(--color-brand-blue-main);vertical-align:bottom !important;margin-bottom:10px;&.center{text-align:center;}&.left:{text-align:left;}&.right:{text-align:right;}"
  } : 0
};

/***/ }),

/***/ 95114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H3": function() { return /* binding */ PercentInput; },
/* harmony export */   "Lj": function() { return /* binding */ CedulaMask; },
/* harmony export */   "MX": function() { return /* binding */ TextMaskInput; },
/* harmony export */   "PK": function() { return /* binding */ MoneyInput; },
/* harmony export */   "Qv": function() { return /* binding */ PhoneMask; },
/* harmony export */   "Y2": function() { return /* binding */ NumberInput; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36864);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57333);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91749);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_text_mask__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);


var _excluded = ["onChange"],
    _excluded2 = ["onChange"],
    _excluded3 = ["value"],
    _excluded4 = ["onChange", "inputProps"],
    _excluded5 = ["onChange"];




var NumberInput = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function NumberInput(props, ref) {
  var _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
      other = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, other, {
    onValueChange: function onValueChange(values) {
      onChange(values.value);
    },
    getInputRef: ref
  }));
});
var PercentInput = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function NumberInput(props, ref) {
  var _props$onChange2 = props.onChange,
      onChange = _props$onChange2 === void 0 ? function () {} : _props$onChange2,
      other = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded2);

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, other, {
    suffix: "%",
    onValueChange: function onValueChange(values) {
      onChange(values.value);
    },
    getInputRef: ref
  }));
});
var MoneyInput = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function MoneyInput(props, ref) {
  var value = props.value,
      rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded3);

  var normalizedValue = value === null || value === undefined ? "" : typeof value === "number" ? String(value) : value;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(NumberInput, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    prefix: "$",
    thousandSeparator: true,
    allowNegative: false,
    ref: ref,
    value: normalizedValue
  }, rest));
});
var PhoneMask = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function PhoneMask(props, ref) {
  var _ref2, _props$format;

  var _ref = props,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded4); // Permitir definir formato ya sea como prop directo o dentro de inputProps (MUI InputBase)


  var format = (_ref2 = (_props$format = props.format) !== null && _props$format !== void 0 ? _props$format : inputProps.format) !== null && _ref2 !== void 0 ? _ref2 : "(###) ###-####";
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    format: format,
    mask: "_",
    allowNegative: false,
    isNumericString: true,
    onValueChange: function onValueChange(values) {
      onChange(values.value);
    },
    getInputRef: ref
  }, rest));
});
var CedulaMask = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CedulaMask(props, ref) {
  var _props$onChange3 = props.onChange,
      onChange = _props$onChange3 === void 0 ? function () {} : _props$onChange3,
      rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded5);

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_number_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    format: "###-#######-#",
    mask: "_",
    allowNegative: false,
    getInputRef: ref,
    onValueChange: function onValueChange(values) {
      onChange(values.value);
    }
  }, rest));
});
var TextMaskInput = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function TextMaskInput(props, ref) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((react_text_mask__WEBPACK_IMPORTED_MODULE_2___default()), (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    mask: function mask(s) {
      return Array.from(s).map(function () {
        return /[a-z\s]/i;
      });
    },
    guide: false,
    getInputRef: ref
  }, props));
});

/***/ }),

/***/ 25242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var custom_hooks_useGetPersintParamas_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53541);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1283);
/* harmony import */ var custom_hooks_useWindowsSize_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51860);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69661);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);






var CollectionCard = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function (_ref) {
  var theme = _ref.theme;
  return {
    width: "100%",
    maxWidth: "223px",
    position: "relative",
    display: "block",
    margin: "0 auto",
    paddingTop: "25px",
    "@media screen and (max-width: 400px)": {
      padding: "0 10px"
    }
  };
});
var CardLink = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("a")({
  textDecoration: "none",
  "&:hover, &:active, &:visited": {
    textDecoration: "none"
  }
});
var CardLabel = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("span")({
  position: "relative",
  left: "10px",
  backgroundColor: "white",
  color: "var(--color-text-black)",
  padding: "5px 10px",
  borderRadius: "10px 10px 0 0",
  letterSpacing: "1px",
  fontSize: ".9rem",
  fontWeight: 400,
  "@media screen and (max-width: 400px)": {
    bottom: "100%"
  }
});
var Thumbnail = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  width: "100%",
  borderRadius: "15px",
  overflow: "hidden",
  height: "150px",
  position: "relative",
  zIndex: 10,
  backgroundColor: "#192c4f",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
var ThumbnailImage = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("img")({
  width: "100%",
  objectFit: "contain",
  objectPosition: "center"
});
var CardDescription = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("span")({
  textAlign: "center",
  display: "inline-block",
  width: "100%",
  margin: "20px 0",
  fontSize: "1rem",
  fontWeight: 500,
  color: "var(--color-text-white)",
  city: {
    textTransform: "lowercase",
    "&:first-letter": {
      textTransform: "uppercase"
    }
  }
});
var CardDescriptionLight = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("span")({
  color: "#fff",
  fontWeight: 400 // textTransform: "lowercase",
  // "&:first-letter": {
  //   textTransform: "uppercase !important",
  // },

});

function PropertyCollectionCard(props) {
  var _props$main_picture$b, _props$main_picture;

  var ref = (0,custom_hooks_useGetPersintParamas_hook__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  var size = (0,custom_hooks_useWindowsSize_hook__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  var width = size === null || size === void 0 ? void 0 : size.width;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CollectionCard, {
    className: props.className
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardLink, {
    href: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_2__/* .CPagesPath.es.collection_property_detail */ .K.es.collection_property_detail(props) + ref,
    className: "collection__card_link",
    target: width > 991 ? "_blank" : "",
    rel: "nofollow noopener noreferrer"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardLabel, null, "COLLECTION"), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(AvatarStyled, {
    variant: "square",
    src: (_props$main_picture$b = props === null || props === void 0 ? void 0 : (_props$main_picture = props.main_picture) === null || _props$main_picture === void 0 ? void 0 : _props$main_picture.big) !== null && _props$main_picture$b !== void 0 ? _props$main_picture$b : "/icons/remax-balloon.png",
    alt: "Collection Image-".concat(props.id, "-").concat(props.sector, "-").concat(props.realstate_type)
  }, props.id), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardDescription, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
    className: "city"
  }, props.realstate_type, " "), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardDescriptionLight, null, capitalizarFrase(props.sector)))));
}

/* harmony default export */ __webpack_exports__["Z"] = (PropertyCollectionCard);
var AvatarStyled = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
  width: "100%",
  height: "150px",
  borderRadius: "14px",
  overflow: "hidden",
  backgroundColor: "#192c4f"
});

function capitalizarFrase(frase) {
  if (typeof frase != "string") {
    return "";
  }

  var excepciones = ["la", "el", "los", "las", "de", "del", "en", "y", "a", "o", "con", "por", "para", "sin", "sobre", "al", "un", "una", "unos", "unas"];
  return frase.toLowerCase().split(" ").map(function (palabra, index) {
    if (index === 0 || !excepciones.includes(palabra)) {
      return palabra.charAt(0).toUpperCase() + palabra.slice(1);
    }

    return palabra;
  }).join(" ");
}

/***/ }),

/***/ 84256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);

 // Import css files





function SlickSlider(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_slick__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, props);
}

/* harmony default export */ __webpack_exports__["Z"] = (SlickSlider);

/***/ }),

/***/ 2098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36864);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48228);
/* harmony import */ var api_realestate_request__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13897);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _custom_carrusel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20518);
/* harmony import */ var _messages_result__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52659);
/* harmony import */ var _property_collection_card__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88078);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70917);






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










function SliderCollectionProperty(props) {
  var _data$data;

  var arrowColor = props.arrowColor,
      _props$filter = props.filter,
      filter = _props$filter === void 0 ? {} : _props$filter;

  var fetchProjectSlider = /*#__PURE__*/function () {
    var _ref = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(e) {
      var response;
      return _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,api_realestate_request__WEBPACK_IMPORTED_MODULE_3__/* .getRealestate */ ._G)(_objectSpread({
                page: 1,
                collection: true,
                exclusives: false
              }, filter));

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchProjectSlider(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var _useMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)(["project-slider-collection"], fetchProjectSlider),
      data = _useMutation.data,
      isLoading = _useMutation.isLoading,
      isError = _useMutation.isError,
      mutate = _useMutation.mutate;

  react__WEBPACK_IMPORTED_MODULE_4__.useEffect(function () {
    mutate({});
  }, []);

  if (data && (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.length) == 0 && !isLoading) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("section", null, props === null || props === void 0 ? void 0 : props.withoutResultsComponent);
  }

  if (isLoading) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_messages_result__WEBPACK_IMPORTED_MODULE_6__/* .MessageResults */ .s, {
      message: "Cargando..."
    });
  }

  if (isError) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_messages_result__WEBPACK_IMPORTED_MODULE_6__/* .MessageResults */ .s, {
      message: "Ha ocurrido un error"
    });
  }

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("section", {
    className: "container"
  }, props.title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Title, null, props.title, " ", (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(TitleSpan, null, props.subTitle)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Wrapper, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_custom_carrusel__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    colorArrow: arrowColor !== null && arrowColor !== void 0 ? arrowColor : "#fff",
    placeholderItem: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(PropertyCollectionCardSkeleton, null),
    enablePlaceholder: true,
    numberOfPlaceholderItems: 10,
    forcePlaceHolder: false
  }, data === null || data === void 0 ? void 0 : data.data.map(function (item, i) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_property_collection_card__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
      key: i
    }, item));
  }))), props.children);
}

/* harmony default export */ __webpack_exports__["Z"] = (SliderCollectionProperty);

var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e162txa92"
} : 0)( true ? {
  name: "87d5hs",
  styles: "display:flex;justify-content:center;padding:10px 5px"
} : 0);

var Title = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h2",  true ? {
  target: "e162txa91"
} : 0)( true ? {
  name: "dfew02",
  styles: "width:100%;text-align:center;text-transform:uppercase;font-size:1.9rem;margin-bottom:30px;color:var(--color-brand-blue-main);line-height:40px"
} : 0);

var TitleSpan = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e162txa90"
} : 0)( true ? {
  name: "1a0w822",
  styles: "font-weight:300"
} : 0);

var PropertyCollectionCardSkeleton = function PropertyCollectionCardSkeleton() {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
    container: true,
    flexDirection: "column",
    item: true,
    sx: {
      maxWidth: "250px",
      padding: "0 5px"
    }
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    variant: "rounded",
    sx: {
      width: "50%",
      marginLeft: 1.5,
      borderRadius: "5px 5px 0px 0px",
      background: "#ffffff36"
    },
    height: 20
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    variant: "rounded",
    sx: {
      width: "100%",
      borderRadius: 3,
      background: "#ffffff36"
    },
    height: 150
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
    container: true,
    item: true,
    xs: 12
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    variant: "text",
    sx: {
      fontSize: "1.6rem",
      width: "100%",
      margin: "auto",
      background: "#ffffff36"
    }
  })));
};

/***/ }),

/***/ 22900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ default_text_field; },
  "Z": function() { return /* reexport */ formik_text_field; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./shared/components/label-field/index.tsx
var label_field = __webpack_require__(78836);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/text-field/default-text-field.tsx




var _excluded = ["label", "value", "errorsComponents"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function DefaultTextField(props) {
  var label = props.label,
      value = props.value,
      errorsComponents = props.errorsComponents,
      res = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var onChange = function onChange(e) {
    if (props !== null && props !== void 0 && props.onChange) {
      props.onChange(e);
    }
  };

  var config = _objectSpread(_objectSpread(_objectSpread({}, res), {
    id: props.name
  }), {}, {
    onChange: onChange
  });

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    css: styles.contentInput,
    className: "content-input-field"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(label_field/* default */.Z, {
    label: label,
    positionLabel: props.positionLabel
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Input/* default */.Z, (0,esm_extends/* default */.Z)({
    label: undefined,
    css: styles.inputField,
    disableUnderline: true
  }, config, {
    value: value
  })), errorsComponents && /*#__PURE__*/react.cloneElement(errorsComponents));
}

/* harmony default export */ var default_text_field = (DefaultTextField);
var styles = {
  inputField:  true ? {
    name: "n2fz1z",
    styles: "width:100%;outline:none;border:1px solid var(--color-brand-border);border-radius:50px;padding:8px 23px;background:none;color:var(--color-brand-blue-main);font-family:var(--font-family);font-style:normal;font-weight:700;font-size:var( --fs-body-small);line-height:21px;& input::placeholder{color:var(--color-brand-blue-main);opacity:1;}&:hover{border:1px solid var(--color-brand-blue-collection-main);}"
  } : 0,
  contentInput:  true ? {
    name: "1d3w5wq",
    styles: "width:100%"
  } : 0,
  inputErrors:  true ? {
    name: "1sc7l0d",
    styles: "width:100%;color:var(--color-brand-red-secondary);font-weight:500;padding-left:10px;font-size:0.8125rem;display:flex;align-items:center;& .iconError{font-size:0.8125rem;margin-right:3px;}"
  } : 0
};

var Errors = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "eq6sl9n0"
} : 0)( true ? "" : 0)));
;// CONCATENATED MODULE: ./shared/components/text-field/formik-text-field.tsx



var formik_text_field_excluded = ["name", "onChange"];

function formik_text_field_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function formik_text_field_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? formik_text_field_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : formik_text_field_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function formik_text_field_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function FormikTextField(props) {
  var _useField = (0,formik_esm/* useField */.U$)(props),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var name = props.name,
      onChange = props.onChange,
      res = (0,objectWithoutProperties/* default */.Z)(props, formik_text_field_excluded);

  var handleChange = function handleChange(value) {
    if (value.target) {
      field.onChange(value);
    } else {
      helpers.setValue(value);
    }
  };

  var config = formik_text_field_objectSpread(formik_text_field_objectSpread(formik_text_field_objectSpread(formik_text_field_objectSpread({}, field), res), {
    id: name
  }), {}, {
    onChange: props.onChange || handleChange,
    errorsComponents: ErrorsComponents({
      meta: meta
    })
  });

  return (0,emotion_react_browser_esm/* jsx */.tZ)(default_text_field, config);
}

/* harmony default export */ var formik_text_field = (FormikTextField);

var ErrorsComponents = function ErrorsComponents(_ref) {
  var meta = _ref.meta;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, meta.error && meta.touched && (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    css: formik_text_field_styles.inputErrors
  }, meta.error));
};

var formik_text_field_styles = {
  inputField:  true ? {
    name: "n2fz1z",
    styles: "width:100%;outline:none;border:1px solid var(--color-brand-border);border-radius:50px;padding:8px 23px;background:none;color:var(--color-brand-blue-main);font-family:var(--font-family);font-style:normal;font-weight:700;font-size:var( --fs-body-small);line-height:21px;& input::placeholder{color:var(--color-brand-blue-main);opacity:1;}&:hover{border:1px solid var(--color-brand-blue-collection-main);}"
  } : 0,
  contentInput:  true ? {
    name: "1d3w5wq",
    styles: "width:100%"
  } : 0,
  inputErrors:  true ? {
    name: "1sc7l0d",
    styles: "width:100%;color:var(--color-brand-red-secondary);font-weight:500;padding-left:10px;font-size:0.8125rem;display:flex;align-items:center;& .iconError{font-size:0.8125rem;margin-right:3px;}"
  } : 0
};
;// CONCATENATED MODULE: ./shared/components/text-field/index.tsx




/***/ }),

/***/ 6644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ CKeyWordsPages; }
/* harmony export */ });
var CKeyWordsPages = {
  project: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana",
  join: "conviértete en agente inmobiliario remax, únete a remax república dominicana, agente inmobiliario remax, agencia inmobiliaria, agente inmobiliario, agente Remax",
  page404: "pagina no encontrada",
  home: "inmueble, remax rd, remax república dominicana, alquilar una casa, comprar una casa, comercialización de inmuebles, proyectos en construcción, beneficios de comprar en planos, préstamos hipotecarios, préstamos hipotecarios en república dominicana, franquicia remax, Propiedades destacadas, propiedades de Remax RD, propiedades de remax república dominicana, agente inmobliario, agencia inmobiliaria, propiedades en República Dominicana, alquiler apartamento, bienes raices santo domingo, departamentos en alquiler santo domingo, proyectos de apartamentos en punta cana, alquilar casa, apartamentos en santo domingo este, apartamentos en bavaro, apartamento en venta punta cana, apartamentos en rd, apartamentos en alquiler santo domingo este, proyectos de apartamentos económicos en santo domingo, apartamentos en venta san isidro, apartamentos en venta republica dominicana, apartamentos en alquiler en santo domingo distrito nacional, apartamento en alquiler, casas en alquiler en república dominicana, proyectos de apartamentos en santo domingo distrito nacional, venta de propiedades en republica dominicana, casas rd, venta de casas en santo domingo, apartamento en el millon, alquiler de apartamentos en santo domingo distrito nacional, comprar apartamento en santo domingo, compra de apartamentos en santo domingo, apartamentos en La Romana",
  homeCollections: "Remax collection, propiedades de lujo, propiedades exclusivas, propiedades premium, propiedades collection",
  mortgageLoad: "préstamo hipotecario, Calculadora de prestamos, cuota de préstamos hipotecarios, formulario de prestamos",
  iWantToRent: "casas en alquiler, villas en alquiler, townhouse en alquiler, apartamento en alquiler, oficinas en alquiler, almacén en alquiler, villas en alquiler, alquiler de aparta estudio, proyectos exclusivos de remax república dominicana",
  iWantToBuy: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana, compra inmobiliaria, adquir propiedad inmobiliaria, inversion inmobiliaria en república dominicana, inversión inmobiliaria"
};

/***/ }),

/***/ 1283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CPagesPath; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var UniversalLinks = {
  blog: "https://blog.remaxrd.com/"
};
var es = {
  home: "/",
  collection: "/collection",
  collection_properties: "/collection/propiedades",
  collection_agents_list: "/collection/agentes",
  collection_property_detail: function collection_property_detail(x) {
    return "/collection/propiedad/".concat(RealestateEncode(x.realstate_type), "/").concat(x.slug);
  },
  collection_agent_detail: function collection_agent_detail(x) {
    return "/collection/agente/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  properties: "/propiedades",
  shop: "/propiedades/comprar",
  acquire: "/propiedades/alquilar",
  property_detail: function property_detail(x) {
    return "/propiedad/".concat(RealestateEncode(x.realstate_type), "/").concat(x === null || x === void 0 ? void 0 : x.slug);
  },
  project: "/proyectos",
  project_Detail: function project_Detail(x) {
    return "/proyecto/".concat(x.slug);
  },
  loan_form: "/prestamos/formulario",
  loan_mortgage: "/prestamos/hipotecarios",
  loan_calculator: "/prestamos/calculadora",
  franchises: "/franquicias",
  agents_list: "/listado/agentes",
  agent_detail: function agent_detail(x) {
    return "/agente/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  agencies_list: "/listado/agencias",
  agency_detail: function agency_detail(x) {
    return "/agencia/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  frequent_questions: "/preguntas-frecuentes",
  join: "/agentes",
  termsAndCondition: "/terminos-condiciones",
  privacyPolitics: "/politica-privacidad",
  signin: "/acceder",
  profile: "/perfil",
  profileEditar: "/perfil/configuracion/editar-perfil",
  profileCambiarClave: "/perfil/configuracion/cambiar-clave",
  profileFavorites: "/perfil/configuracion/favoritos",
  ProfileSearchHistory: "/perfil/configuracion/busquedas",
  ProfileLastedSee: "/perfil/configuracion/historial-busquedas",
  signup: "/registrate",
  forgotPassword: "/restaurar-clave"
};
var CPagesPath = _objectSpread(_objectSpread({}, UniversalLinks), {}, {
  es: es
});

var HEncodeString = function HEncodeString(x) {
  return "".concat(x.replace(/\//g, "-").split(" ").join("-").toLowerCase());
};

var RealestateEncode = function RealestateEncode(x) {
  var _x$replaceAll;

  return x === null || x === void 0 ? void 0 : (_x$replaceAll = x.replaceAll("/", "o")) === null || _x$replaceAll === void 0 ? void 0 : _x$replaceAll.replaceAll(" ", "-").toLowerCase();
};

/***/ }),

/***/ 69178:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection",
      function () {
        return __webpack_require__(75340);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3662,2708,1629,8407,2615,6877,4022,70,3843,1664,7918,9043,8543,2960,7956,3828,311,9343,4816,6939,8360,7872,6626,4831,6869,7931,3267,3282,1207,2888,179], function() { return __webpack_exec__(69178); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);